/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · Brazilian Portuguese (pt) string table · skin-concerns.html
   English is the source of truth in the HTML; this file supplies the
   Portuguese counterpart for each page-specific data-i18n key. Shared
   chrome (nav, announce, footer) lives in i18n-pt.js.
   Note: Concern 08 (Serum O) avoids the "tired" cognate ("cansada");
   uses vitality framing (sem brilho, vitalidade, viço).
═════════════════════════════════════════════════════════════════════ */
(function () {
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.pt = window.TD_I18N.pt || {};
  Object.assign(window.TD_I18N.pt, {

    /* ── Page header ── */
    'concerns.headLabel': 'Encontre a sua fórmula',
    'concerns.headTitle': 'Comece pelo que<br><em>te incomoda.</em>',
    'concerns.headSub': 'Cinco sérums, cinco alvos biológicos. Comece pela necessidade que mais importa para você, e o sérum certo quase sempre se escolhe sozinho.',

    /* ── Jump bar ── */
    'concerns.jumpLabel': 'Ir para',
    'concerns.jumpFirmness': 'Firmeza',
    'concerns.jumpBrightness': 'Luminosidade',
    'concerns.jumpHydration': 'Hidratação',
    'concerns.jumpFineLines': 'Linhas finas',
    'concerns.jumpDarkSpots': 'Manchas escuras',
    'concerns.jumpTexture': 'Textura',
    'concerns.jumpAcneScars': 'Cicatrizes de acne',
    'concerns.jumpDullness': 'Falta de viço',

    /* ── Reusable row labels ── */
    'concerns.startWith': 'Comece com',
    'concerns.shopRoutine': 'Comprar essa rotina →',
    'concerns.nameC': 'Serum C — <em>Luminosidade</em>',
    'concerns.nameA': 'Serum A — <em>Renovação</em>',
    'concerns.nameO': 'Serum O — <em>Celular</em>',
    'concerns.nameM': 'Serum M — <em>Hidratação</em>',
    'concerns.nameR': 'Serum R — <em>Clareza</em>',
    'concerns.rolePrimaryDay': 'Principal · Dia',
    'concerns.rolePrimaryNight': 'Principal · Noite',
    'concerns.rolePrimaryDayNight': 'Principal · Dia + Noite',
    'concerns.roleLayerDay': 'Camada · Dia',
    'concerns.roleLayerNight': 'Camada · Noite',

    /* ── Concern 01 · Firmness ── */
    'concerns.c1Num': 'Necessidade 01',
    'concerns.c1Title': 'Firmeza<br><em>& elasticidade.</em>',
    'concerns.c1Lede': 'A linha da mandíbula amolece. As maçãs do rosto perdem suporte. A pele começa a cair em vez de se sustentar. É o primeiro sinal visível de que a produção de colágeno e elastina desacelerou, e o mais simples de reverter no nível celular.',

    /* ── Concern 02 · Brightness ── */
    'concerns.c2Num': 'Necessidade 02',
    'concerns.c2Title': 'Luminosidade<br><em>& danos solares.</em>',
    'concerns.c2Lede': 'A pele parece sem brilho mesmo quando você não está. Muitas vezes é cumulativo: UV, poluição, estresse, energia celular reduzida. A vitamina C é o ingrediente tópico mais estudado para luminosidade. O Serum O vai além e alimenta diretamente as mitocôndrias, as células que produzem a energia.',

    /* ── Concern 03 · Hydration ── */
    'concerns.c3Num': 'Necessidade 03',
    'concerns.c3Title': 'Desidratação<br><em>& perda de barreira.</em>',
    'concerns.c3Lede': 'Pele seca não é uma questão de mais hidratante. É uma questão de barreira lipídica rompida. A maioria dos hidratantes tem 65-85% de água mais álcool e conservantes, o que paradoxalmente resseca ainda mais a pele. O Serum M reconstrói a barreira por dentro com lipídios idênticos aos da pele.',

    /* ── Concern 04 · Fine lines ── */
    'concerns.c4Num': 'Necessidade 04',
    'concerns.c4Title': 'Linhas finas<br><em>& rugas.</em>',
    'concerns.c4Lede': 'Linhas superficiais de expressão, dobras mais profundas causadas pelo tempo e pelo sol. A renovação celular desacelera com a idade; os queratinócitos velhos permanecem por mais tempo; a textura sofre. O retinol reativa a renovação e alisa a superfície; a vitamina C reconstrói a estrutura por baixo.',

    /* ── Concern 05 · Dark spots ── */
    'concerns.c5Num': 'Necessidade 05',
    'concerns.c5Title': 'Manchas escuras<br><em>& pigmentação.</em>',
    'concerns.c5Lede': 'Os danos solares, as mudanças hormonais e as marcas pós-inflamatórias concentram o pigmento em manchas desiguais. A vitamina C inibe a enzima (tirosinase) que dirige a produção de pigmento; o resveratrol neutraliza os radicais livres que a disparam.',

    /* ── Concern 06 · Texture ── */
    'concerns.c6Num': 'Necessidade 06',
    'concerns.c6Title': 'Textura<br><em>irregular.</em>',
    'concerns.c6Lede': 'Áreas ásperas, poros visíveis, uma superfície desigual sobre a qual a maquiagem se acumula em vez de se alisar. É quase sempre um problema de renovação celular: células cutâneas velhas e engrossadas que ficam mais tempo do que deveriam. O retinol acelera o ciclo.',

    /* ── Concern 07 · Post-acne ── */
    'concerns.c7Num': 'Necessidade 07',
    'concerns.c7Title': 'Pós-acne<br><em>& cicatrizes.</em>',
    'concerns.c7Lede': 'Muito depois que a crise termina, a marca muitas vezes ainda está lá. O resveratrol reduz a pigmentação pós-inflamatória e apoia a pele enquanto ela completa o reparo que começou. Combine com o Serum A à noite para uma renovação celular que acelera o desaparecimento da marca.',

    /* ── Concern 08 · Dullness / mature ── */
    'concerns.c8Num': 'Necessidade 08',
    'concerns.c8Title': 'Falta de viço <em>&amp; perda de elasticidade.</em>',
    'concerns.c8Lede': 'À medida que a pele amadurece, os sistemas que a mantêm luminosa e firme se desaceleram. A nitidez da superfície se esmaece e a elasticidade afrouxa. O Serum O renova e revitaliza a pele madura no nível celular, apoiando o brilho e a firmeza que diminuem com a idade.',

    /* ── Not sure CTA ── */
    'concerns.unsureLabel': 'Ainda em dúvida?',
    'concerns.unsureTitle': 'Não escolha. Experimente os cinco.',
    'concerns.unsureBody': 'O Discovery Kit contém versões em tamanho de bolso de cada sérum e um guia impresso. É a maneira mais rápida de aprender quais das suas necessidades respondem a qual fórmula: na sua pele, não na teoria.',
    'concerns.unsureBtn': 'Garanta o Discovery Kit',

    /* ── Footer (page-specific extra) ── */
    'concerns.ftLearnRonlan': 'Sobre o Dr. Ronlán',

    /* ── Theme-only: Concern 08 alt framing (fatigue / low energy) ── */
    'concerns.c8TitleFatigue': 'Vitalidade reduzida<br><em>& baixa energia.</em>',
    'concerns.c8LedeFatigue': 'Uma pele sem viço nem sempre depende do que se vê na superfície. Depende do que a produz. A produção mitocondrial diminui com a idade, e junto com ela a capacidade da célula de formar colágeno e reparar danos. O Serum O alimenta o sistema diretamente e devolve energia às células.',

    /* ── Theme-only: application banner (conditional) ── */
    'concerns.appDividerLabel': 'Na prática',
    'concerns.appDividerQuote': 'Duas gotas, manhã e noite. A pele que você tem, cuidada.',

    /* ── Theme-only: shortened unsure body (no printed guide) ── */
    'concerns.unsureBodyShort': 'O Discovery Kit contém versões em tamanho de bolso de cada sérum. É a maneira mais rápida de aprender quais das suas necessidades respondem a qual fórmula: na sua pele, não na teoria.'

  });
})();
